import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "@emotion/styled"
import { GiWolfHead, GiRing, GiDivingHelmet, GiCoffeeMug, GiZeppelin } from "react-icons/gi";
import { DiTerminal, DiJqueryLogo, DiJsBadge, DiSass, DiWordpress, DiPhp, DiReact, DiHtml5, DiCss3Full, DiGit, DiGithubAlt, DiVisualstudio, DiPhotoshop } from "react-icons/di";
import { FaYarn, FaNpm } from "react-icons/fa";
import graphqlIcon from '@iconify/icons-cib/graphql';
import { Icon } from '@iconify/react';
import gatsbyIcon from '@iconify/icons-cib/gatsby';
import { IconContext } from "react-icons";
import ReactTooltip from 'react-tooltip'
import ImageOne from "../images/me-1.jpg"
import ImageTwo from "../images/me-2.jpg"



/*About Me Header Styles */

const AboutMeHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`

const HelloStatement = styled.h1`
  font-size: 3rem;
  margin: 0;


  @media (max-width: 425px) {
      margin-top: 5rem;
  }
`

const PopOfRed = styled.span`
  color: #f80c16;
  font-family: Tango, serif;
`

const HelloTagline = styled.p`
  margin: 0;
`

/* About Me Styles */

const AboutMeContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 6rem;

@media (max-width: 425px) {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-bottom: 3rem;
}
`

const AboutIntroContainer = styled.div`
  width: 30%;
  margin-left: 2rem;

  @media (max-width: 1200px) {
    width: 40%;
  }

  @media (max-width: 768px) {
    margin-left: 1.5rem;
    width: 40%;
  }

  @media (max-width: 425px) {
    width: 100%;
    margin-top: 4rem;
    margin-bottom: 1rem;
    margin-left: 0;
    text-align: center;
  }
`

const Intro = styled.h3`
  font-size: 2.75rem;
  line-height: 3.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 3rem;
  }

  @media (max-width: 425px) {
    font-size: 1.65rem;
    line-height: 2.25rem;
  }
`


/* Interests Styles */

const MyInterestsContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 3rem;
`

const InterestsTitle = styled.h2`
  margin: 0 auto;
  font-size: 2.25rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #000000FF;

  @media (max-width: 425px) {
    font-size: 2.1rem;
  }
`

const InterestsWrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  font-size: 3rem;

  @media (max-width: 768px) {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
`

const InterestIcons = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  width: 20%;
  margin-right: 0.25rem;
  margin-left: 0.25rem;

  @media (max-width: 768px) {
   width: 30%;
   margin-bottom: 0.5rem;
  }

  @media (max-width: 425px) {
    width: 100%;
    margin-bottom: 1.25rem;
  }
`

const IconTitle = styled.h3`
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  letter-spacing: .15rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  font-weight: 600;
`

const IconSidenote = styled.p`
  font-size: 0.9rem;
  margin: 0;
`



/* Tech Info Styles */

const TechContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 4rem;
  color: #000000ff;
  border-top: 1px solid #000000FF;
  padding-top: 3rem;

  @media (max-width: 768px) {
    font-size: 3.25rem;
  }
`

const SkillsTitleContainer = styled.div`
  width: 100%;
`

const SkillsTitle = styled.h1`
  width: 25%;
  margin: 0 auto;
  font-size: 3.5rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #000000FF;

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 425px) {
    width: 80%;
  }
`

const TechWrapper = styled.div`
  width: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 425px) {
   width: 100%;
  }
`

const TechTitle = styled.h3`
  font-size: 1.1rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-align: center;
  letter-spacing: .15rem;
  line-height: 1.5rem;
  font-weight: 600;
`

const LangContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 1rem;
`

/* See Work Button Styles */

const AboutButtonWrapper = styled.div`
    display: relative;
    cursor: pointer;
    z-index: 0;
`

const SeeWorkLink = styled.a`
    display: inline-block;
    padding: 1.25rem;
    font-size: 1rem;
    font-family: Raleway, sans-serif;
    text-decoration: none;
    color: #000000FF;
    border: 2px solid #000000FF;
    border-radius: 10rem;
    letter-spacing: .15rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    position: relative;
    overflow: hidden;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;

    &:after {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 0%;
		height: 100%;
        background: #f80c16;
        border-radius: 10rem;
        z-index: -1;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s; 
    }

    &:hover {
        color: #ffff;
    }

    &:hover:after {
        width: 100%; 
    }
`

const SeeWorkButton = props => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: "2rem" }}>
      <AboutButtonWrapper>
          <SeeWorkLink href={props.link}>View My Work</SeeWorkLink>
      </AboutButtonWrapper>
  </div>
)

function AboutPage() {

  return (
    <Layout>
      <SEO title="About" />
      <AboutMeHeader>
        <HelloStatement>Hi! I'm Alex<PopOfRed>.</PopOfRed></HelloStatement>
        <HelloTagline>
          (&ldquo;Let us go on and take the adventure that shall fall to us.&rdquo;)
        </HelloTagline>
      </AboutMeHeader>
      <AboutMeContainer>
        <div id="carousel">
          <img src={ImageOne} className="bottom" alt="Alexandra Thomas" />
          <img src={ImageTwo} className="top" alt="Alexandra Thomas" />
        </div>
        <AboutIntroContainer>
          <Intro>I strive to build engaging web applications through methodical code with the user in mind<PopOfRed>.</PopOfRed></Intro>
        </AboutIntroContainer>
      </AboutMeContainer>    
      <MyInterestsContainer>
          <InterestsTitle>Some Interests of Mine<PopOfRed>.</PopOfRed></InterestsTitle>
          <InterestsWrapper>
            <InterestIcons>
              <GiDivingHelmet />
            <IconTitle>SCUBA Diving</IconTitle>
            <IconSidenote>(Diving in the big blue wet thing is OK)</IconSidenote>
            </InterestIcons>
            <InterestIcons>
              <GiZeppelin />
              <IconTitle>Classic Rock</IconTitle>
              <IconSidenote>(Have you ever seen the rain? And staircases to heaven? All in a purple haze?)</IconSidenote>
            </InterestIcons>
            <InterestIcons>
              <GiWolfHead />
              <IconTitle>The Witcher</IconTitle>
              <IconSidenote>(Wind's howling)</IconSidenote>
            </InterestIcons>
            <InterestIcons>
              <GiRing />
              <IconTitle>Fantasy &amp; Historical Fiction</IconTitle>
              <IconSidenote>(J.R.R. Tolkien, C.S. Lewis, Winston Graham...)</IconSidenote>
            </InterestIcons>
            <InterestIcons>
              <GiCoffeeMug />
              <IconTitle>Coffee</IconTitle>
              <IconSidenote>(Brew can do it!)</IconSidenote>
            </InterestIcons>
          </InterestsWrapper> 
        </MyInterestsContainer>
      <TechContainer>
        <SkillsTitleContainer>
          <SkillsTitle>Tech Skills<PopOfRed>.</PopOfRed></SkillsTitle>
        </SkillsTitleContainer>
      <IconContext.Provider value={{ className: "tech-icons" }}>
      <ReactTooltip place="bottom" class="customTheme" />
        <TechWrapper>
          <TechTitle>Fundamentals</TechTitle>
          <LangContainer>
            <DiHtml5 data-tip="HTML" />
            <DiCss3Full data-tip="CSS" />
            <DiJsBadge data-tip="JavaScript" />
          </LangContainer>
        </TechWrapper>
        <TechWrapper>
          <TechTitle>WordPress</TechTitle>
          <LangContainer>
            <DiWordpress data-tip="WordPress" />
            <DiPhp data-tip="PHP" />
          </LangContainer>
        </TechWrapper>
        <TechWrapper>
          <TechTitle>Libraries, Frameworks &amp; More</TechTitle>
          <LangContainer>
            <DiReact data-tip="React" />
            <Icon icon={gatsbyIcon} title="Gatsby" style={{ margin: '0.25rem', cursor:'pointer'}} data-tip="GatsbyJs" />
            <Icon icon={graphqlIcon} style={{ margin: '0.25rem', cursor:'pointer' }} data-tip="GraphQL"  />
            <DiSass data-tip="Sass"/>
            <DiJqueryLogo data-tip="jQuery" />
          </LangContainer>
        </TechWrapper>
        <TechWrapper>
          <TechTitle>Version Control &amp; Managers</TechTitle>
          <LangContainer>
            <DiTerminal data-tip="Terminal" />
            <DiGit data-tip="Git" />
            <DiGithubAlt data-tip="GitHub" />
            <FaYarn data-tip="Yarn" />
            <FaNpm data-tip="NPM" />
          </LangContainer>
        </TechWrapper>
        <TechWrapper>
          <TechTitle>Tools</TechTitle>
          <LangContainer>
            <DiVisualstudio data-tip="VSCode" />
            <DiPhotoshop data-tip="Adobe Photoshop" />
          </LangContainer>
        </TechWrapper>
      </IconContext.Provider>
      </TechContainer>
      <SeeWorkButton link="/work/" />
    </Layout>
  )
}

export default AboutPage